import mainComponent from '@/layouts/main/Main.vue'

export default [{
  path: '/marketing',
  component: mainComponent,
  title: 'Marketing',
  children: [{
      path: '/',
      name: 'marketing-list',
      component: () => import('@/views/marketing/TemplatesList.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Marketing', active: true },
        ],
        pageTitle: 'Marketing',
        rule: 'editor'
      },
    },
    {
      path: 'novo',
      name: 'marketing-new',
      component: () => import('@/views/marketing/NewTemplate.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Marketing', url: '/marketing' },
          { title: 'Novo Template', active: true },
        ],
        pageTitle: 'Novo Template',
        rule: 'editor'
      },
    },
  ],
}, ];